import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { NotificationService } from '@shared/components/notification/notification.service';
import { Notification } from '../components/notification/models/notification.model';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private notificationService: NotificationService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          
          if (error.status === 401) {
            console.log('401 Unauthorized detected, redirecting to /unauthorised');
            this.router.navigate(['/unauthorised']);
            return throwError(error);
          }
          
          if (error.error instanceof ErrorEvent) {
            // Client-side error
            errorMessage = `Error: ${error.error.message}`;
            this.notificationService.notification(new Notification('danger', 'Error:', `${error.error.message}`));
          } else {
            // Server-side error
            errorMessage = `Error Code: ${error.status}\nError Message: ${error.message}`;
            this.notificationService.notification(new Notification('danger', `Error: ${error.status}`, `${error.message}`));
          }
          console.error(errorMessage);
          return throwError(errorMessage);
        })
      );
  }
}
